import { useState } from 'react';
import { AppShell, Burger, Group } from '@buildex/ui';
import { Outlet } from 'react-router';
import type { ModuleManifest } from '@buildex/module-contract';
import { Header } from '@/widgets/header/Header';
import { Sidebar } from '@/widgets/sidebar/Sidebar';

interface CabinetLayoutProps {
  manifests: ModuleManifest[];
}

export function CabinetLayout({ manifests }: CabinetLayoutProps) {
  const [navbarOpened, setNavbarOpened] = useState(true);

  return (
    <AppShell
      header={{ height: 56 }}
      navbar={{
        width: 260,
        breakpoint: 'sm',
        collapsed: { mobile: !navbarOpened, desktop: !navbarOpened },
      }}
      padding="md"
    >
      <AppShell.Header>
        <Group h="100%" gap={0} wrap="nowrap">
          <Group px="md">
            <Burger
              size="sm"
              opened={navbarOpened}
              onClick={() => setNavbarOpened((v) => !v)}
              aria-label="Скрыть/показать меню"
            />
          </Group>
          <Header />
        </Group>
      </AppShell.Header>
      <AppShell.Navbar>
        <Sidebar manifests={manifests} />
      </AppShell.Navbar>
      {/* Серый «канвас» под карточками — токен, не HEX */}
      <AppShell.Main style={{ background: 'var(--mantine-color-gray-0)' }}>
        <Outlet />
      </AppShell.Main>
    </AppShell>
  );
}
